import app from 'flarum/forum/app';
import on from './gate';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import { day } from './index';
// Shared by mobile/desktop renderers so one page makes one request.
let current = null;
let loadedAt = 0;
let actorKey = '';
function load() {
  const actor = String(app.session.user?.id() || 'guest');
  if (!current || actorKey !== actor || Date.now() - loadedAt > 60000) {
    loadedAt = Date.now();
    actorKey = actor;
    current = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/challenges/weekly'
    }).then(r => r.data);
    current.catch(() => {
      current = null;
    });
  }
  return current;
}
export default class WeeklyChallenges extends Component {
  challenges = [];
  error = false;
  oninit(v) {
    super.oninit(v);
    if (!on()) return;
    load().then(r => this.challenges = r).catch(() => this.error = true).finally(() => m.redraw());
  }
  view() {
    if (!on()) return null;
    return m("section", {
      className: 'Learn-weekly ' + (this.attrs.mobile ? 'Learn-weekly--mobile' : 'Learn-weekly--desktop')
    }, m("header", null, m("span", {
      className: "Learn-eyebrow"
    }, "Practice together"), m("h2", null, "This week's challenges")), m("div", {
      className: "Learn-weekly-list"
    }, this.challenges.map(c => m(Link, {
      className: "Learn-weekly-item",
      href: app.forum.attribute('baseUrl') + '/d/' + c.discussion_id
    }, c.avatar_url ? m("img", {
      src: c.avatar_url.startsWith('/') || c.avatar_url.includes('://') ? c.avatar_url : app.forum.attribute('baseUrl') + '/assets/avatars/' + c.avatar_url,
      alt: ""
    }) : m("span", {
      className: "Learn-initial",
      "aria-hidden": "true"
    }, c.username[0].toUpperCase()), m("span", {
      className: "Learn-weekly-copy"
    }, m("strong", null, c.track), m("span", null, c.username), m("span", {
      className: "Challenge-pill"
    }, "Day ", day(c.started_at), "/30"))))), !this.challenges.length && m("p", {
      className: "helpText"
    }, this.error ? 'Challenges are unavailable right now.' : 'Be the first to start a challenge this week.'), m(Link, {
      className: "Learn-browse",
      href: app.route('challenges.index')
    }, "Browse Learn pages ", m("span", {
      "aria-hidden": "true"
    }, "\u2192")));
  }
}